import React from 'react'
import { Modal } from 'react-bootstrap'
import AssignRoomFormComponent from './AssignRoomFormComponent'
import { BookingV4 } from '../../../../services/create-booking-v4/schema/GetAllBookingResponseV4'

interface AssignRoomDialogProps {
    show: boolean,
    onClose: () => void,
    reservation: BookingV4 | null
}

const AssignRoomDialog: React.FC<AssignRoomDialogProps> = ({ show, onClose, reservation }) => {
    return (
        <Modal show={show} onHide={onClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Assign Room</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AssignRoomFormComponent reservation={reservation} onClose={onClose} />
            </Modal.Body>
        </Modal>
    )
}

export default AssignRoomDialog